import { filterSelectInput, filterDataInput } from "components/form/DefaultConsultView/components/FilterInputs";
import Entity from "entity";
import { ValidatorHelper } from "functions";
import React from "react";
import BotaoDuplicarRodada from "./components/BotaoDuplicarRodada";

export default class Rodada extends Entity {
    static get collectionUID() {
        return "Rodada";
    }
    async initialize() {
        this.data.status = "ATIVO"
        this.data.permiteFotosInscricao = "NÃO"
        // this.data.dataFinal = "DD/MM/AAAA --:--"
        // this.data.dataInicio = "DD/MM/AAAA --:--"
        // this.data.dataFinal = null
        // this.data.dataInicio = null
        this.data.dataFinal = ""
        this.data.dataInicio = ""
        this.data.bloqueiaInscricaoPublica = "NÃO"
        this.data.bloqueiaCnpjDuplicado = "NÃO"
        this.data.rodadaInternacional = "NÃO"
        this.data.permiteFotosInscricao = "NÃO"
        this.data.tipoAncora = "Comprador"
        this.data.rodadaPublica = "SIM"
    }
    static async onQuery(collection) {
        return collection//.orderBy("dataInicio");
        // return collection.where("status", "==", "ATIVO").orderBy("nome");
    }

    static get labelField() {
        return "nome";
    }

    static get searchColumns() {
        return [

            { field: "nome", headerName: "RODADA", flex: 2, filter: true },
            { field: "local", headerName: "LOCAL", flex: 2, filter: true },
            { field: "descricao", headerName: "DESCRIÇÃO", flex: 2, filter: true },
            {
                field: "dataInicio", headerName: "Data Inicio", flex: 1,
                valueGetter: ({ row }) => {
                    if (typeof row.dataInicio === 'string' || row.dataInicio instanceof String) {
                        return row.dataInicio.split("T")[0].split('-').reverse().join("/")
                    } else {
                        return "-"
                    }
                },
                compare: (a, b) => {
                    if (a) {
                        a = a.split("/").reverse().join()
                    }
                    if (b) {
                        b = b.split("/").reverse().join()
                    }

                    if (a === b) return 0;
                    return a > b ? 1 : -1

                },

                filter: filterDataInput("dataInicio", "Data Inicio")
            },
            {
                field: "status", headerName: "Status", flex: 1, filter: filterSelectInput("status", "Status", ["ATIVO", "INATIVO"])
            },
            {
                field: "acoes",
                headerName: "Ações",
                flex: 0.5,
                sortable: false,
                renderCellValue: (row) => {
                    return <BotaoDuplicarRodada rodada={row} />;
                },
            },
        ];
    }
    async preSave(entity) {
        console.log('preSave entity', entity)
        if (entity.data.mesas) {
            for (let index = 0; index < entity.data.mesas.length; index++) {
                const m = entity.data.mesas[index];
                m.index = (index + 1)

            }
        }

    }

    static async validFieldErrors(values) {

        let v = new ValidatorHelper();

        v.addRequired("nome", "Nome da Rodada")
        v.addRequired("dataInicio", "Data de Início")
        v.addRequired("dataFinal", "Data de Finalização")
        v.addRequired("status", "Status")
        v.addRequired("tempoReuniao", "Tempo para cada Reunião (Min)")
        v.addRequired("intervaloReuniao", "Intervalo da Reunião")
        v.addRequired("descricao", "Descrição")
        v.addRequired("tipoAncora", "Tipo de Ancora (Comprador/Vendedor)")

        let errorsMessage = v.valid(values);

        if (!values.produtos || !values.produtos.length) {
            errorsMessage.push("Nenhum produto adicionado")
        }

        if (errorsMessage.length) {
            return errorsMessage
        }

        if (new Date(values.dataFinal) <= new Date(values.dataInicio)) {
            errorsMessage.push("Horário final menor ou igual ao inicial")
        }

        if (values.tempoReuniao <= 0) {
            errorsMessage.push("Tempo de Reunião precisa ser maior que zero")
        }

        if (values.intervaloReuniao <= 0) {
            errorsMessage.push("Intervalo da Reunião precisa ser maior que zero")
        }

        if (values.intervalos?.length) {
            let allValuesFilled = values.intervalos.filter(i => i.inicio === '' || i.fim === '' || i.fim.includes("NaN") || i.inicio.includes("NaN"))
            if (allValuesFilled.length) {
                errorsMessage.push("Data inválida na seção de Intervalos")
            }
        }

        if (!values.bloqueiaCnpjDuplicado) {
            errorsMessage.push("Configurações: Bloquear CNPJ Duplicado")
        }

        if (errorsMessage.length) {
            return errorsMessage
        }

        // return ["TESTES"]
        return null
    }
}